import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createAllocationUnit, updateAllocationUnit } from 'redux/allocationUnits/AllocationUnitsActions';
import AllocationUnitEditorContainer from './AllocationUnitEditorContainer';

const mapStateToProps = ({ allocationUnits }) => ({
  creatingAllocationUnit: allocationUnits.creatingAllocationUnit,
  pageState: allocationUnits.pageState,
  allocationUnit: allocationUnits.allocationUnit,
  updatingAllocationUnit: allocationUnits.updatingAllocationUnit,
  fetchingAllocationUnit: allocationUnits.fetchingAllocationUnit
});

const mapDispatchToProps = dispatch => ({
  allocationUnitsActions: bindActionCreators({ createAllocationUnit, updateAllocationUnit }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AllocationUnitEditorContainer);




// WEBPACK FOOTER //
// ./src/components/manageAllocationUnits/comp/allocationUnitEditorContainer/AllocationUnitEditorContainerConnector.js